import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import babyImg from "@img/landing/baby-loan/baby-loan.svg";
import { faSquareFacebook } from "@ui/fortawesome/square-facebook";
import type { ReactNode } from "react";
import React from "react";
import { Col, Row } from "react-bootstrap";

/**
 * @Shortcode
 *
 * @title "Babaváró Facebook"
 * @shortcode "babavaro_facebook"
 * @type "widget"
 */
export default class BabavaroFacebook extends React.PureComponent {
	public render(): ReactNode {
		return (
			<Row className="bg-trianglify-blue text-white d-flex align-items-center m-2 p-4 border rounded">
				<Col md={3} className="text-center mb-3 mb-md-0">
					<img src={babyImg} alt="Babaváró támogatás" width={119} height={120} loading="lazy" />
				</Col>
				<Col md={9} className="d-md-flex align-items-center text-center text-md-left">
					<FontAwesomeIcon icon={faSquareFacebook} size="3x" className="mr-4 d-md-block d-none" />
					<a
						className="display-6 text-white"
						href="https://www.facebook.com/groups/bankmonitor.babavaro/"
						target="_blank"
						rel="noreferrer"
					>
						Csatlakozz a Bankmonitor.hu
						<br />
						Babaváró hitel Facebook csoportjához
					</a>
				</Col>
			</Row>
		);
	}
}
